module.exports = __webpack_public_path__ + "static/media/bear_baby_thumbsUpWinking.086fff04.png";